/* eslint-disable */
export default {
  data() {
    return {
      defaultDgObject: {
/*        isDgToggleActive: false,
        isTemperature: false,*/
        feeWrapperId: this.feeWrapperId,
        dangerousGoodsId: '',
        nemWeight: {
          unit: 'kg',
          value: null,
        },
        netWeight: {
          unit: 'kg',
          value: null,
        },
        bruttoWeight: {
          unit: 'kg',
          value: null,
        },
        englishTechnicalDesignation: '',
        danishTechnicalDesignation: '',
        iataAutorization: '',
        flashPoint: '',
        segregationGroup: '',
        ems: '',
        notAllInOneQty: '',
        notAllInOneOuterPackaging: '',
        innerPackaging: '',
        innerPackagingQty: '',
        packingInstruction: '',
        isEnvironmentalHazard: false,
        isMarinePollutant: false,
        isLimitedQuantity: false,
        isExceptedQuantity: false
      }
    }
  },
  methods: {
    parseProductObject(val)
    {
      let iataLimitations = 1;
      let iataRadioactive = 1;
      let iataAdditionalInfo = ''
      let Q = ''
      const dgObj = JSON.parse(val.dangerous_goods_json)
      dgObj.forEach((dg, index) => {
          dgObj[index]['packingType'] = dg.packingType;
          dgObj[index]['notAllInOneOuterPackaging'] = dg.packingType;
          dgObj[index]['productId'] = val.id;

          if (dgObj[index]['iataLimitations'] !== 1) {
              iataLimitations = dgObj[index]['iataLimitations']
          }

          if (dgObj[index]['iataRadioactive'] !== 1) {
              iataRadioactive = dgObj[index]['iataRadioactive']
          }

          if (dgObj[index]['Q'] !== '') {
            Q = dgObj[index]['Q']
          }

          dgObj[index] = {
            ...this.defaultDgObject,
            ...dgObj[index],
            productDgSpec: JSON.parse(JSON.stringify(dgObj[index])),
            productId: val.id
          }
      })

      let merged = [];
      if (this.value.dangerousGoodsServices.length > 1 || (this.value.dangerousGoodsServices.length === 1 && this.value.dangerousGoodsServices[0].dangerousGoodsId)) {
        merged = this.value.dangerousGoodsServices;
      }
      dgObj.forEach(dg => {
          merged.push(dg);
      })

      return {
        ...this.value,
        isDgToggleActive: merged.length > 0,
        isEnvironmentalHazard: this.checkEnvHazard(merged),
        isMarinePollutant: this.checkMarinePollutant(merged),
        Q: Q,
        iataLimitations: iataLimitations,
        iataRadioactive: iataRadioactive,
        iataAdditionalInfo: iataAdditionalInfo,
        dangerousGoodsServices : merged
      }
    },
    checkEnvHazard(obj) {
      obj.forEach(dgItem => {
        if (dgItem.isEnvironmentalHazard) {
          return true
        }
      })
      return false
    },
    checkMarinePollutant(obj) {
      obj.forEach(dgItem => {
        if (dgItem.isMarinePollutant) {
          return true
        }
      })
      return false
    },
    checkIsTemperatureControlled() {
      let tempControlled = false
      this.value.content.forEach(item => {
        if (item.product && parseInt(item.product.contains_temp_controlled)) {
          tempControlled = true
        }
      })
      return tempControlled
    },
    getMaxTemp(obj) {
      let maxTemp = this.value.maxTemperature;
      this.value.content.forEach(item => {
        if (item.product && parseInt(item.product.contains_temp_controlled)) {
          if (!maxTemp || item.product.max_temp > maxTemp) {
            maxTemp = item.product.max_temp
          }
        }
      })
      return maxTemp;
    },
    getMinTemp(obj) {
      let minTemp = this.value.minTemperature;
      this.value.content.forEach(item => {
        if (item.product && parseInt(item.product.contains_temp_controlled)) {
          if (!minTemp || item.product.min_temp < minTemp) {
            minTemp = item.product.min_temp
          }
        }
      })
      return minTemp
    },
    productSelected(val) {
      const productObject = this.parseProductObject(val)
      const newObj = {
        ...productObject,
        isTemperature: productObject.tempSetManually  ? true : this.checkIsTemperatureControlled(),
        maxTemperature: this.getMaxTemp(),
        minTemperature: this.getMinTemp(),
        tempSetManually: !!productObject.tempSetManually
      };
      this.$emit('input', newObj);
    },
    quantityChange({qty, productId}) {
      this.value.dangerousGoodsServices.forEach(dg => {
        if (dg.productId === productId) {
          if (dg.productDgSpec.nemWeight.value) {
            let nemWeight = dg.productDgSpec.nemWeight.value.replace(',', '.');
            nemWeight = (parseFloat(nemWeight) * parseInt(qty)).toFixed(2);
            dg.nemWeight.value = nemWeight.replace('.', ',')
          }
          if (dg.productDgSpec.bruttoWeight.value) {
            let bruttoWeight = dg.productDgSpec.bruttoWeight.value.replace(',', '.');
            bruttoWeight = (parseFloat(bruttoWeight) * parseInt(qty)).toFixed(2);
            dg.bruttoWeight.value = bruttoWeight.replace('.', ',')
          }
          if (dg.productDgSpec.netWeight.value) {
            let netWeight = dg.productDgSpec.netWeight.value.replace(',', '.');
            netWeight = (parseFloat(netWeight) * parseInt(qty)).toFixed(2);
            dg.netWeight.value = netWeight.replace('.', ',')
          }
        }
      })
    },
    productRemoved(productId) {
      let obj = {
        ...this.value
      };
      obj.dangerousGoodsServices.forEach((service, index) => {
        if (service.productId && service.productId === productId) {
          obj.dangerousGoodsServices.splice(index, 1)
        }
      })

      if (this.value.dangerousGoodsServices.length <= 0) {
        obj =  {
          ...obj,
          ...this.defaultDgObject,
          isDgToggleActive: this.value.dangerousGoodsServices.length > 0,
          isEnvironmentalHazard: this.checkEnvHazard(this.value.dangerousGoodsServices),
          isMarinePollutant: this.checkMarinePollutant(this.value.dangerousGoodsServices),
          isTemperature: this.value.tempSetManually  ? true : this.checkIsTemperatureControlled(),
          maxTemperature: this.value.tempSetManually ? this.value.maxTemperature : this.getMaxTemp(),
          minTemperature: this.value.tempSetManually ? this.value.minTemperature : this.getMinTemp(),
          tempSetManually: !!this.value.tempSetManually
        }
      }

      this.$emit('input', obj)
    }
  }
}
